<template>
  <v-container grid-list-lg>
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">Bonventa Store List</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line="single-line"
          hide-details="hide-details"
        >
        </v-text-field>
      </v-card-title>
      <v-data-table
        v-if="Location"
        :headers="headers"
        :items="Location"
        :total-items="count"
        item-key="id"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left pointer" >
              {{ props.item.createdAt | moment("MM/DD/YYYY LT") }}
            </td>
            <td class="text-xs-left pointer">
              <div>
                <div >{{ props.item.name }}</div>

                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <small
                      v-bind="attrs"
                      id="locationCode"
                      @click="copyCode(props.item.code)"
                      v-on="on"
                      class="text-caption"
                      >{{ props.item.code }}</small
                    >
                  </template>
                  <span>Click To Copy</span>
                </v-tooltip>
              </div>
            </td>
            <!-- <td class="text-xs-left pointer">
              <a @click="openGoogleMap(props.item)">{{ props.item.address }}</a>
            </td> -->
            <td class="text-xs-left" >
              {{ props.item.Address.phoneNumber }}
            </td>
            <td class="text-xs-left" >
              {{ props.item.Address.addressLine1 }},
              {{ props.item.Address.city }}
            </td>
            <td>
              <v-btn small @click="openLocation(props.item)" color="success">Open</v-btn>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import bonventaService from "@/modules/Bonventa/service.js";

export default {
  name: "bonventa-location-list",
  data() {
    return {
      Location: null,
      count: 0,
      search: null,
      limit: 10,
      offset: 0,
      loading: false,
      rowsPerPageItems: [10, 25, 50, 100],
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: "name",
      },
      headers: [
        {
          text: "Created At",
          align: "left",
          sortable: false,
        },
        {
          text: "Name",
          value: "name",
          sortable: false,
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "businessPhone",
          sortable: true,
        },
        {
          text: this.$t("labels.address"),
          value: "address",
          sortable: true,
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  watch: {
    search() {
      if (this.search.length > 3 || this.search.length === 0) {
        this.getList();
      }
    },
    pagination: {
      handler() {
        this.pagination.totalItems = this.count;
        this.getList();
      },
      deep: true,
    },
  },
  methods: {
    copyCode(code) {
      // const copyText = code
      // console.log('copyText', copyText.innerHTML);

      navigator.clipboard.writeText(code);
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });

      Toast.fire({
        type: "success",
        title: "Location code was copy",
      });
      // this.$toast.success("Location code was copy", { timeout: 2000 });
    },
    openLocation(location) {
      console.log("location selected", location);
      // this.$router.push(`/bonventa/location/${location.id}/profile`);
      this.$router.push({ path: `${location.id}/profile` })
    },
    getList() {
      const { page, rowsPerPage } = this.pagination;
      if (rowsPerPage > 0) {
        this.offset = rowsPerPage * page - rowsPerPage;
      }
      this.limit = rowsPerPage;
      bonventaService
        .Location.getAll({
          limit: this.limit,
          offset: this.offset,
          local: true,
          search: this.search,
        })
        .then((response) => {
          // console.log('result', response);
          this.Location = response.data;
          this.count = response.count;
          // this.pagination.totalItems = this.count;
        });
    },
  },
};
</script>

<style scoped>
</style>
